import React from "react";
import { Toaster } from "sonner";

import * as styles from "./AppToaster.module.scss";

export const AppToaster = (): JSX.Element => (
  <Toaster
    closeButton
    expand
    offset={24}
    position="bottom-right"
    visibleToasts={4}
    toastOptions={{
      duration: 4000,
      unstyled: true,
      classNames: {
        toast: styles.toast,
        content: styles.toastContent,
        closeButton: styles.closeButton
      }
    }}
  />
);
